import React from "react";

export default function LookFacet({ handleFilterClick, productLook }) {
  function sortObject(obj) {
    return Object.keys(obj)
      .sort()
      .reduce((a, v) => {
        a[v] = obj[v];
        return a;
      }, {});
  }
  productLook = sortObject(productLook);
  const wpProductCategory = window.wpProductCategory;
  const plpFacetLabel = wpProductCategory.plpFacetLabel;
  const title =
    plpFacetLabel &&
    Object.keys(plpFacetLabel)?.length > 0 &&
    plpFacetLabel.hasOwnProperty("look_facet") &&
    plpFacetLabel.look_facet != ""
      ? plpFacetLabel.look_facet
      : "Look";
  return (
    <div class="facet-wrap facet-display">
      <strong>{title}</strong>
      <div className="facetwp-facet">
        {Object.keys(productLook).map((look, i) => {
          if (look && productLook[look] > 0) {
            return (
              <div>
                <span
                  id={`look-filter-${i}`}
                  key={i}
                  data-value={`${look.toLowerCase()}`}
                  onClick={(e) =>
                    handleFilterClick("look_facet", e.target.dataset.value)
                  }>
                  {" "}
                  {look} {` (${productLook[look]}) `}
                </span>
              </div>
            );
          }
          return null;
        })}
      </div>
    </div>
  );
}
